<template>
  <v-container class="mt-8">

    <v-row>
      <!-- Información básica del grupo -->
      <v-col cols="12" class="pb-4">
        <v-card class="mx-auto transparent elevation-0">
          <v-card-text class="pb-0">
            <div class="mb-0 font-weight-bold text-h5 colorCurso text-center">
              Calendarios
            </div>
          </v-card-text>
        </v-card>
      </v-col>
      <v-col cols="12">
        <v-card class="elevation-0 transparent">
          <!-- los diplomas y certificados -->
          <v-row justify="space-around">

            <!-- <v-col cols="9" md="6" lg="4" >
              <v-card class="cardShow">
                <v-card-title primary-title class="text-body-1 grey--text">
                  <v-spacer></v-spacer>
                  Pagos
                  <v-spacer></v-spacer>
                </v-card-title>

                <v-card-text>
                  <v-row justify="center">
                    <v-col cols="12" md="6">
                      <v-img :src="urlPagos"></v-img>
                    </v-col>
                  </v-row>
                </v-card-text>

                <v-card-actions>
                  <v-btn color="orange"  block dark class="mr-2 text-caption" @click="descargarCopia( urlPagos )">Descargar copia</v-btn>
                </v-card-actions>
              </v-card>
            </v-col> -->

            <!-- Cambridge -->
            <v-col cols="10" md="8">
              <v-card class="elevation-0 cardShow">
                <v-card-title primary-title class="text-body-1 grey--text">
                  <v-spacer></v-spacer>
                  Horarios
                  <v-spacer></v-spacer>
                </v-card-title>

                <v-card-text>
                  <v-row justify="center">
                    <v-col cols="12" md="8">
                      <v-img :src="urlHorarios"></v-img>
                    </v-col>
                  </v-row>
                </v-card-text>

                <!-- Botonos para pedir o descargar -->
                <!-- Solo si tiene certificación y tiene resultado -->
                <v-card-actions>
                  <v-btn color="orange"  block dark class="mr-2 text-caption" @click="descargarCopia( urlHorarios )">Descargar copia</v-btn>
                </v-card-actions>
              </v-card>
            </v-col>
          </v-row>
        </v-card>
      </v-col>
    </v-row>

    <v-speed-dial
      top
      fixed
    >
      <template v-slot:activator>
        <v-btn
          color="white"
          dark
          fab
          :to="{name: 'Perfil'}"
        >
          <v-icon color="primary">
            mdi-keyboard-backspace
          </v-icon>
        </v-btn>
      </template>
    </v-speed-dial>

    <Alerta    v-if="respuestaAlerta" :parametros="parametros"/>
    <Loader    v-if="cargar"          :loader="loader"/>

  </v-container>
</template>

<script>
  // importar librerías
  import { mapGetters, mapActions } from 'vuex'
  const  base64 = require('base-64');

  // Componentes
  import Alerta     from '@/components/alertas/Alerta.vue'
  import Loader     from '@/components/alertas/Loader.vue'

  export default {
    components:{
      Alerta,
      Loader
    },

    data: () => ({
      urlHorarios: '',
      urlPagos:'',

      respuestaAlerta: false,
      loader: true,
      cargar: false,
      parametros:{
        dialogError: false,
        mensaje: '',
        color: ''
      },
    }),

    computed:{
      ...mapGetters( 'login', [ 'getGrupo', 'getUsuarioLMS' ])
    },

    async created(){
      this.initialize( )
    },

    methods:{
      initialize(){
        this.cargar = true
        // const id_alumno = base64.encode( this.getUsuarioLMS.id )
        return this.$http.get('usuario.calendarios').then( response =>{
          this.cargar = false
          this.urlHorarios = response.body.urlHorarios
          this.urlPagos    = response.body.urlPagos
        }).catch( error =>{
          this.validarError ( error )
        }).finally(()=>{ this.cargar = false })
      },

      validarError ( value ) {
        this.cargar = false 
        if( value.status == 400 || value.status == 500){
          this.parametros.mensaje      = value.body.message
          this.parametros.dialogError  = true 
          this.parametros.color        = '#FF2C2C'
          this.respuestaAlerta = true 
        }
      },

      async descargarCopia( url ) {
        window.open( url );
      },
    },
  }
</script>
<style scoped>
  .cardShow{
    border-radius: 15px !important; 
    box-shadow: 0 20px 27px 0 rgba(0,0,0,0.2)  !important;
  }

  .colorCurso{
    color: #006093;
  }
</style>
